<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="total-stat">
    <div class="total-stat-count">
      <EcsServiceLevelGraph :service-level="serviceLevel" :graph-threshold="slide.graphThreshold" />
    </div>
    <div class="total-stat-description">
      <span :class="alertType">{{ kpiFormat(serviceLevel, 'percentage') }}</span>
    </div>
    <div class="total-stat-description">Service Level</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import EcsServiceLevelGraph from './EcsServiceLevelGraph';
import EcsKpiFormatter from '@/mixins/ecs-kpi-formatter/EcsKpiFormatter';

export default {
  name: 'EcsServiceLevelSlide',
  components: {
    EcsServiceLevelGraph
  },

  mixins: [EcsKpiFormatter],

  props: {
    slide: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  computed: {
    ...mapGetters('WALLBOARD', ['getStatisticsByBpids']),

    alertType() {
      return 'alert-type-' + this.selectedBusinessProcessesStats.serviceLevel.alertType.toLowerCase();
    },

    selectedBusinessProcessesStats() {
      return this.getStatisticsByBpids(this.slide.businessProcesses);
    },

    serviceLevel() {
      if (!this.selectedBusinessProcessesStats) {
        return this.slide;
      }

      if (
        this.selectedBusinessProcessesStats.serviceLevel.totalQueuedInteractions &&
        this.selectedBusinessProcessesStats.serviceLevel.totalQueuedInteractions > 0
      ) {
        const averageServiceLevel =
          this.selectedBusinessProcessesStats.serviceLevel.value /
          this.selectedBusinessProcessesStats.serviceLevel.totalQueuedInteractions;

        return averageServiceLevel;
      } else {
        return 0;
      }
    }
  }
};
</script>

<style src="../scoped.css" scoped></style>
